module.exports = __webpack_public_path__ + "static/ApInternational-a09452852da1647bf0cfc27d943f4179.png";